import styled from "styled-components";

export const DocumentContainer = styled.div`
  display: flex;
  gap: 15px;
  float: right;
  > button {
    justify-content: flex-start;
    background: transparent;
    border: none;
    align-items: center;
    margin-right: auto;
    display: flex;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .moreIconDisabled {
    color: ${(props) => props.theme["@input-background-disabled"]};
    cursor: not-allowed;
  }
  .moreIcon {
    :hover {
      color: ${(props) => props.theme["@primary-color-brand"]} !important;
      cursor: pointer;
    }
  }
`;

export const DocumentTag = styled.div`
  .documentTag {
    display: inline-flex;
    border-radius: 300px;
    font-weight: 600;
    font-size: 14px;
    align-content: center;
    align-items: center;
    padding: 0 12px;
    cursor: default;
    color: ${(props) => props.theme.colors.text};
  }
`;
